<script>
    import { Breadcrumb, BreadcrumbItem } from '@sveltestrap/sveltestrap';
    import { onMount } from 'svelte';
    import { fetchOneMultiLeagueDraws } from '/public/services/games.js';
    import { Accordion, AccordionItem } from '@sveltestrap/sveltestrap';
    import dayjs from 'dayjs';
    import LockedMultiCourt from '/public/components/draws/LockedMultiCourt.svelte';
    import LeagueStats from '/core/components/stats/LeagueStats.svelte';

    export let params;

    let id = params.leagueID;
    let loading = true;
    let league = null;
    let draws = null;
    let stats = null;

    function loadLeague() {
        fetchOneMultiLeagueDraws(id).then(res => {
            if (res.success) {
                league = res.data.league;
                draws = res.data.draws;
                stats = res.data.stats;

                loading = false;
            }
        });
    }

    onMount(() => {
        loadLeague();
    });

</script>
{#if loading === true}

    <div class='text-center mt-5 mb-5'>
        <h4>
            <span class='ajax-ball-loader'></span> Looking for Draws....
        </h4>
    </div>

{:else}

    <Breadcrumb>
        <BreadcrumbItem>
            <a href="#/">
                Home
            </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>
            League: { league.name }
        </BreadcrumbItem>
    </Breadcrumb>

    <div class='clearfix mb-3'>
        <a href='#/' class='btn btn-outline-secondary float-end ms-2'>
            <span class='fas fa-chevron-left'></span> Back to Leagues
        </a>
        <h2>
            <span class='fas fa-volleyball-ball'></span> { league.name }
        </h2>

        {#each league.venues as v}

            <h4>

                <span class='fas fa-calendar text-secondary'></span> { v.day } <span class='fas fa-home text-secondary'></span> { v.name }

            </h4>

        {/each}

    </div>

    {#if league.email_pre}

        <div class='card mb-3'>
            <div class='card-body'>

                {@html league.email_pre}

            </div>
        </div>

    {/if}

    <hr/>

    {#if league.results}

        <LeagueStats
            stats={stats}
        />

        <hr/>
        
    {/if}

    {#if draws.length == 0}

        <div class='mt-5 mb-5 text-center'>
            <h5 class='text-danger'>
                <span class='fas fa-info-circle'></span> There are no Draws that can be viewed at this time.
            </h5>
        </div>

    {:else}

    <Accordion>

        {#each draws as d,idx}

            <AccordionItem active={idx == 0}>
                <h4 class="m-0" slot="header">
                    
                    <span class='fas fa-volleyball-ball'></span> Week Starting: { dayjs(d.date).format('dddd, DD MMMM YYYY')}

                </h4>

                <p class='text-end'>
                    <a href='/multi-draw-pdf/{ d.id }' class='btn btn-outline-primary' target='_blank'>
                        <span class='fas fa-file-pdf'></span> Download Draw PDF
                    </a>
                </p>                

                <hr/>

                {#each d.mix as night}

                    <div class='card mb-3'>
                        <div class='card-header'>
                            <span class='fas fa-clock'></span> { dayjs(night.date).format('dddd, DD MMMM YYYY')} { night.venue }
                        </div>
                        <div class='card-body'>

                            {#each night.slots as sl}

                                <div class='text-center mb-3'>
                                    <h3>
                                        <span class='fas fa-clock'></span> { sl.slot }
                                    </h3>
                                </div>

                                <div class='row justify-content-center mb-5'>

                                    {#each sl.courts as crt}

                                        <div class='col-sm-12 col-md-6 col-lg-4'>
                                            <div class='card mb-3'>
                                                <div class='card-body'>

                                                    <h4 class='text-center mb-1'>

                                                        { crt.name }
                    
                                                    </h4>
                    
                                                    <LockedMultiCourt                                    
                                                        match={crt.match}                                                                                
                                                    />

                                                </div>
                                            </div>
                                            
                                        </div>

                                    {/each}

                                </div>

                            {/each}

                        </div>
                    </div>

                {/each}
                
            </AccordionItem>

        {/each}

    </Accordion>

    {/if}

    {#if league.email_post}

        <div class='card mb-5 mt-3'>
            <div class='card-body'>

                {@html league.email_post}

            </div>
        </div>

    {/if}

{/if}